export default "__VITE_ASSET__CnK2l$rX__"